import { Component, OnInit } from "@angular/core";
import { AlertsService } from "./alerts.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "alerts-component",
  template: require('./alerts.component.html'),
  styles: [require('./alerts.component.scss')]
})
export class AlertsComponent implements OnInit {
  alerts: any[];
  reverse: boolean;
  predicate: string = "created_at";
  onlyActive: boolean = true;
  projects: any[] = [{ name: "Projects" }];
  nationalities: any[] = [{ name: "Nationalities" }];
  employers: any[] = [{ name: "Employers" }];
  countries: any[] = [{ name: "Countries" }];
  projectFilter: string;
  nationalityFilter: string;
  employerFilter: string;
  countryFilter: string;
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: AlertsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getCountries();
    this.getNationalities();
    this.getAlerts().subscribe((res) => {
      this.getProjects();
      this.getEmployers();
      this.sortBy("it.created_at", "created_at");
    });
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getAlerts() {
    return this.service.getAlerts().map((alerts) => {
      this.alerts = alerts;
    });
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
  }

  getCountries() {
    let nations = this.service.getNationalities();
    this.countries = this.countries.concat(nations);
  }

  getNationalities() {
    let nations = this.service.getNationalities();
    this.nationalities = this.nationalities.concat(nations);
  }

  getEmployers() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  getCountryNames(ids: string[]): string[] {
    return this.service.getCountryNames(ids);
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  editAlert(alert: any) {
    AlertsService.currentAlert = alert;
    this.router.navigate(["/editalert"]);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/alerts/alerts.component.ts